import * as elements from '../../actions/early/elements'

const initialState = {
  showWageModal: false,
  showJobModal: false,
  selectedElement: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case elements.SELECT_ELEMENT:
      return {
        ...state,
        selectedElement: action.element
      }

    case elements.DISMISS_ELEMENT:
      return {
        ...state,
        selectedElement: null
      }

    case elements.TOGGLE_JOB_MODAL:
      return {
        ...state,
        showJobModal: action.isVisible
      }
    case elements.TOGGLE_WAGE_MODAL:
      return {
        ...state,
        showWageModal: action.isVisible
      }

    default:
      return state
  }
}

export default reducers
